import axios from 'axios'
import router from '../../router/index'
import UserService from '../../services/userService'
import { Map } from 'core-js'
import * as helpers from '../../helpers/helpers'
import store from '..'

// state
const state = {
  userId: null,
  user: null,
  expirationDate: null,
  refreshToken: null,
  refreshRoute: null,
  bearerToken: null,
  bearerExpirationDate: null,
  adminClaim: null,
  dataAdminClaim: null,
  projectClaims: null,
  errorMessage: ''
}

// getters
const getters = {
  userId: state => state.userId,
  user: state => state.user,
  expirationDate: state => state.expirationDate,
  refreshToken: state => state.refreshToken,
  refreshRoute: state => state.refreshRoute,
  bearerToken: state => state.bearerToken,
  bearerExpirationDate: state => state.bearerExpirationDate,
  adminClaim: state => state.adminClaim,
  dataAdminClaim: state => state.dataAdminClaim,
  projectClaims: state => state.projectClaims,
  getLoginErrorMessage: state => state.errorMessage
}

// actions
const actions = {
  async login({ commit, dispatch }, payload) {
    const res = await UserService.login(payload, commit)
    if (!res) {
      console.warn('returning from login', res)
      return
    }
    commit('SET_USER', {
      userId: res.data.$id,
      refreshToken: res.data.refreshtoken
    })
    await dispatch('getBearerToken')
    await dispatch('getClaims')

    const millisecondsToSeconds = 1000
    const expirationDate = new Date(new Date().getTime() + res.data.expires_in * millisecondsToSeconds)
    commit('SET_EXPIRATION_DATE', expirationDate)

    sessionStorage.setItem('userId', res.data.$id)
    sessionStorage.setItem('refreshToken', res.data.refreshtoken)
    sessionStorage.setItem('expirationDate', expirationDate)
    dispatch('validateSession')
  },
  async getUser({ commit, state }) {
    if (state.user === null && state.bearerToken) {
      const me = await UserService.getCurrentUser()
      let i = 0
      for (const claim of me.data.claims) {
        const splitType = claim.type.split(':')
        me.data.claims[i].scope = splitType[0]
        me.data.claims[i].projectId = splitType[1]
        i++
      }
      commit('getUser', me.data)
    }
  },
  getClaims({ state, commit }) {
    const parts = state.refreshToken.split('.')
    // let output = str.replaceAll('-', '+').replaceAll('_', '/')
    let output = parts[1]
    switch (output.length % 4) {
      case 0:
        break
      case 2:
        output += '=='
        break
      case 3:
        output += '='
        break
      default:
        console.error('Illegal base64url string!')
    }
    const decodedParts = atob(output)
    const encodedToken = JSON.parse(decodedParts)
    let adminBool = false
    let dataAdminBool = false
    for (const [key, value] of Object.entries(encodedToken)) {
      if ((key == 'role') & (value == 'GlobalAdministrator')) {
        adminBool = true
      } else if ((key == 'role') & (value == 'DataAdministrator')) {
        dataAdminBool = true
      }
    }
    commit('setAdminClaim', adminBool)
    commit('setDataAdminClaim', dataAdminBool)
  },

  async getBearerToken({ commit, state, dispatch }, payload) {
    console.log('%c refreshing bearer token', 'color: #208075')
    const token = { RefreshToken: state.refreshToken }
    const res = await UserService.getBearerToken(token)
    const bearer = res.data.bearertoken
    const millisecondsToSeconds = 1000
    const expirationDate = new Date(new Date().getTime() + res.data.expires_in * millisecondsToSeconds)
    sessionStorage.setItem('bearerToken', bearer)
    commit('SET_BEARER', { token: bearer, time: expirationDate })
    if (state.user === null) {
      await dispatch('getUser')
      await dispatch('getClaims')
    }
  },
  RefreshToken({ commit, dispatch }) {
    const refreshToken = sessionStorage.getItem('refreshToken')
    if (refreshToken !== null) {
      axios
        .post(`https://securetoken.googleapis.com/v1/token?key=}`, {
          grant_type: 'refresh_token',
          refreshToken: refreshToken
        })
        .then(res => {
          commit('SET_USER', {
            email: sessionStorage.getItem('userEmail'),
            idToken: res.data.id_token
          })
          const millisecondsToSeconds = 1000
          const expirationDate = new Date(new Date().getTime() + res.data.expires_in * millisecondsToSeconds)
          commit('SET_EXPIRATION_DATE', expirationDate)
          router.push('/list')
        })
    }
  },
  // getProjectAdminClaim({ commit, state, dispatch }) {
  //   let bool = false
  //   if (state.adminClaim || state.dataAdminBool) bool = true
  //   if (state.user.claims > 0) {
  //     const result = state.user.claims.find(x => x.projectId == state.project.projectId)
  //     if (result >= 0) bool = result.value == 'Admin'
  //   }
  //   return bool
  // },

  Logout({ commit }) {
    commit('SET_USER', { email: null, idToken: null })
    commit('SET_EXPIRATION_DATE', null)
    commit('CLEAR_USER')
    sessionStorage.removeItem('refreshToken')
    sessionStorage.removeItem('userEmail')
    sessionStorage.removeItem('bearerToken')
    sessionStorage.removeItem('userId')
    sessionStorage.removeItem('expirationDate')
  },
  async validateSession({ commit, state, dispatch }) {
    commit('GET_LOCAL_STORAGE_LOGIN_DATA')
    const now = new Date().getTime()
    const expirationTime = new Date(state.expirationDate).getTime()
    if (state.refreshToken && expirationTime > now) {
      await store.dispatch('getBearerToken', state.refreshToken)
      if (state.refreshRoute) {
        router.push(state.refreshRoute)
        state.refreshRoute = null
      } else {
        setTimeout(function() {}, 1000)
        router.push('/projectlist')
      }
      sessionStorage.removeItem('refreshRoute')
      //return
    }
    //console.log('Please login in first')
    //sessionStorage.removeItem('refreshRoute')
    //router.push('/login')
  },
  async getProjectAdminClaim({ state, dispatch }, projectId) {
    let bool = false
    if (state.user === null) await dispatch('getUser')
    if ((state.adminClaim || state.dataAdminClaim) == null) await dispatch('getClaims')
    bool = state.adminClaim || state.dataAdminClaim
    if (bool == false) {
      if (state.user.claims.length != 0) {
        const result = state.user.claims.find(x => x.projectId == projectId)
        if (result) {
          bool = result.value == 'Admin'
        }
      }
    }
    return bool
  }
}

// mutations
const mutations = {
  SET_EXPIRATION_DATE(state, expirationDate) {
    state.expirationDate = expirationDate
  },
  SET_USER(state, { userId, refreshToken, expirationDate }) {
    state.userId = userId
    state.refreshToken = refreshToken
  },
  CLEAR_USER(state) {
    state.user = null
  },
  SET_BEARER(state, payload) {
    state.bearerToken = payload.token
    state.bearerExpirationDate = payload.time
  },
  SET_ERROR_MESSAGE(state, msg) {
    state.errorMessage = msg
  },
  GET_LOCAL_STORAGE_LOGIN_DATA(state) {
    state.userId = sessionStorage.getItem('userId')
    state.expirationDate = sessionStorage.getItem('expirationDate')
    state.refreshToken = sessionStorage.getItem('refreshToken')
    state.refreshRoute = sessionStorage.getItem('refreshRoute')
  },
  getUser(state, payload) {
    state.user = payload
  },
  setAdminClaim(state, claim) {
    state.adminClaim = claim
  },
  setDataAdminClaim(state, claim) {
    state.dataAdminClaim = claim
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js